import React, { useMemo } from 'react'
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'
import { IBankAccountModel } from './BankAccountModel'

type Props = {
  data: IBankAccountModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit?: (item: IBankAccountModel) => void
  onDelete?: (item: IBankAccountModel) => void
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}


type BankRow = Omit<IBankAccountModel, 'id'> & { id?: string }

const toRow = (b: IBankAccountModel): BankRow => ({
  ...b,
  id: b.id != null ? String(b.id) : undefined,
})

const fromRow = (r: BankRow): IBankAccountModel =>
  ({ ...r, id: r.id != null ? Number(r.id) : null } as IBankAccountModel)

export const BankAccountTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false,
}) => {
  const tableData = useMemo<BankRow[]>(() => data.map(toRow), [data])

  const columns: TableColumn<BankRow>[] = [
    
    { key: 'accountName', label: 'IBAN', className: 'fw-semibold', sortable: true },
    { key: 'bankName', label: 'Banka', sortable: true },
    { key: 'branchName', label: 'Şube', sortable: true },
    { key: 'currency', label: 'Döviz', sortable: true },
    { key: 'specialCode', label: 'Özel Kod', sortable: true },
    { key: 'email', label: 'Uyarı Mail Listesi', sortable: true },
    { key: 'id', label: 'ID', sortable: true },
  ]

  const actions: TableAction<BankRow>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (row) => onEdit?.(fromRow(row)),
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (row) => onDelete?.(fromRow(row)),
    },
  ]

  return (
    <DataTable<BankRow>
      data={tableData}
      columns={columns}
      actions={actions}
      showPagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz banka hesabı bulunamadı'
    />
  )
}

export default BankAccountTable
